import { render, staticRenderFns } from "./DatatablesTestPage.vue?vue&type=template&id=eec34868&"
import script from "./DatatablesTestPage.vue?vue&type=script&lang=js&"
export * from "./DatatablesTestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports